module.exports = __webpack_public_path__ + "media/assets_v3/images/dolandirici_dikkat_mobil-0e4f70270dccb58ec6edccb163fef187.jpg";